
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('generic/indexed_filesystem',["require", "exports", '../core/file_system', './file_index', '../core/file_flag', '../core/node_fs_stats', '../core/api_error', '../core/node_path'], function(require, exports, file_system, file_index, file_flag, node_fs_stats, api_error, node_path) {
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var ActionType = file_flag.ActionType;
    var FileType = node_fs_stats.FileType;
    var Stats = node_fs_stats.Stats;
    var FileFlag = file_flag.FileFlag;
    var path = node_path.path;
    var DirInode = file_index.DirInode;

    var IndexedFileSystem = (function (_super) {
        __extends(IndexedFileSystem, _super);
        function IndexedFileSystem(_index) {
            _super.call(this);
            this._index = _index;
        }
        IndexedFileSystem.prototype.renameSync = function (oldPath, newPath) {
            var oldInode = this._index.removePath(oldPath);
            if (oldInode === null) {
                throw new ApiError(1 /* ENOENT */, "" + oldPath + " not found.");
            }

            this._index.removePath(newPath);
            this._index.addPath(newPath, oldInode);
        };

        IndexedFileSystem.prototype.statSync = function (path, isLstat) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " not found.");
            }
            return inode.isDir() ? inode.getStats() : inode.getData();
        };

        IndexedFileSystem.prototype.openSync = function (p, flags, mode) {
            var inode = this._index.getInode(p);
            if (inode !== null) {
                if (!inode.isFile()) {
                    throw new ApiError(8 /* EISDIR */, "" + p + " is a directory.");
                } else {
                    var stats = inode.getData();
                    switch (flags.pathExistsAction()) {
                        case 1 /* THROW_EXCEPTION */:
                            throw new ApiError(6 /* EEXIST */, "" + p + " already exists.");
                            break;
                        case 2 /* TRUNCATE_FILE */:
                            return this._truncate(p, flags, stats);
                        case 0 /* NOP */:
                            return this._fetch(p, flags, stats);
                        default:
                            throw new ApiError(9 /* EINVAL */, 'Invalid FileFlag object.');
                    }
                }
            } else {
                switch (flags.pathNotExistsAction()) {
                    case 3 /* CREATE_FILE */:
                        var parentPath = path.dirname(p);
                        var parentInode = this._index.getInode(parentPath);
                        if (parentInode === null || parentInode.isFile()) {
                            throw new ApiError(1 /* ENOENT */, "" + parentPath + " doesn't exist.");
                        }
                        var fileInode = new file_index.FileInode(new Stats(32768 /* FILE */, 0, mode));
                        return this._create(p, flags, fileInode);
                    case 1 /* THROW_EXCEPTION */:
                        throw new ApiError(1 /* ENOENT */, "" + p + " doesn't exist.");
                        break;
                    default:
                        throw new ApiError(9 /* EINVAL */, 'Invalid FileFlag object.');
                }
            }
        };

        IndexedFileSystem.prototype.unlinkSync = function (path) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " not found.");
            } else if (!inode.isFile()) {
                throw new ApiError(8 /* EISDIR */, "" + path + " is a directory, not a file.");
            }
            this._index.removePath(path);
        };

        IndexedFileSystem.prototype.rmdirSync = function (path) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " not found.");
            } else if (inode.isFile()) {
                throw new ApiError(7 /* ENOTDIR */, "" + path + " is a file, not a directory.");
            }
            this._index.removePath(path);
            this._rmdirSync(path, inode);
        };

        IndexedFileSystem.prototype.mkdirSync = function (p, mode) {
            var inode = this._index.getInode(p);
            if (inode !== null) {
                throw new ApiError(6 /* EEXIST */, "" + p + " already exists.");
            }

            var parent = path.dirname(p);
            if (parent !== '/' && this._index.getInode(parent) === null) {
                throw new ApiError(1 /* ENOENT */, "Can't create " + p + " because " + parent + " doesn't exist.");
            }
            var success = this._index.addPath(p, new DirInode());
            if (success) {
                return;
            }
            throw new ApiError(9 /* EINVAL */, "Could not add " + path + " for some reason.");
        };

        IndexedFileSystem.prototype.readdirSync = function (path) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " not found.");
            } else if (inode.isFile()) {
                throw new ApiError(7 /* ENOTDIR */, "" + path + " is a file, not a directory.");
            }
            return inode.getListing();
        };

        IndexedFileSystem.prototype.chmodSync = function (path, isLchmod, mode) {
            var fd = this.openSync(path, FileFlag.getFileFlag('r+'), 0x1a4);

            fd._stat.chmod(mode);
            fd.closeSync();
        };

        IndexedFileSystem.prototype.chownSync = function (path, isLchown, uid, gid) {
            var fd = this.openSync(path, FileFlag.getFileFlag('r+'), 0x1a4);

            fd._stat.uid = uid;
            fd._stat.gid = gid;
            fd.closeSync();
        };

        IndexedFileSystem.prototype.utimesSync = function (path, atime, mtime) {
            var fd = this.openSync(path, FileFlag.getFileFlag('r+'), 0x1a4);

            fd._stat.atime = atime;
            fd._stat.mtime = mtime;
            fd.closeSync();
        };

        IndexedFileSystem.prototype._rmdirSync = function (path, inode) {
            throw new ApiError(14 /* ENOTSUP */, '_rmdirSync is not implemented.');
        };
        IndexedFileSystem.prototype._create = function (path, flag, inode) {
            throw new ApiError(14 /* ENOTSUP */, '_create is not implemented.');
        };
        IndexedFileSystem.prototype._fetch = function (path, flag, stats) {
            throw new ApiError(14 /* ENOTSUP */, '_fetch is not implemented.');
        };
        IndexedFileSystem.prototype._truncate = function (path, flag, stats) {
            throw new ApiError(14 /* ENOTSUP */, '_truncate is not implemented.');
        };
        return IndexedFileSystem;
    })(file_system.SynchronousFileSystem);
    exports.IndexedFileSystem = IndexedFileSystem;
});
//# sourceMappingURL=indexed_filesystem.js.map
;